import React from 'react';
import { Empty } from 'antd';
import './ProjectTabTableEmpty.css';

/** Match Ant Design default Table empty copy (“No data”) */
export const PROJECT_TAB_TABLE_EMPTY_DESCRIPTION = 'No data';

/**
 * Centered empty state for project tabs — same icon + label as Ant Table default,
 * usable inside Tables (`locale.emptyText`) or custom grids (e.g. Spares).
 */
export function ProjectTabTableEmpty({ description = PROJECT_TAB_TABLE_EMPTY_DESCRIPTION }) {
  return (
    <div className="project-tab-table-empty">
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />
    </div>
  );
}
